import {useStore} from "vuex";
import api from "@/api";
import refreshTokenApi from "@/api/refreshTokenApi";
import router from "@/router";
import authorizationApi from "@/api/authorizationApi";
import restfulApi from "@/api/restfulApi";

export default function useJWT() {
  const store = useStore()

  return {
    createJWTService: () => {

      const retryAxiosQuery = ({data, headers, method, url, params}) => {
        headers['Authorization'] = `Bearer ${store.state.JWT.user.access}`
        return api({method, data, headers, url, params})
      }

      const loadNewToken = reject => {
        if (!store.state.JWT.user.refresh) {
          router.push('/login')
          return reject.response.data || false
        }

        return refreshTokenApi(store.state.JWT.user.refresh)
          .then(response => {
            if (response.access) {
              store.commit('JWT/setAccessToken', response.access)
              return retryAxiosQuery(reject.config)
            }
          })
          .catch(() => {
            if (reject && reject.response.status === 401) {
              store.commit('JWT/clearToken')
              router.push('/login')
              return false
            }
            throw new Error()
          })
      }

      const onRejected = reject => {
        if (reject.response.status === 401) {
          return loadNewToken(reject)
        }

        const errorArray = Object.values(reject.response.data)
        if (errorArray.length > 0 && typeof reject.response.data === "object") {
          errorArray.forEach(error => {
            store.commit('messages/addError', `Ошибка: ${error}`)
            console.error(new Error(error))
          })
        } else {
          store.commit('messages/addError', `Неизвестная ошибка`)
        }
        throw reject
      }

      api.interceptors.response.use(undefined, onRejected)

      return authorizationApi.checkAuth().then(response => {
        if (response) {
          store.commit('report/setGeneralReportLinks', response.links, {root: true})
          store.commit('user/setUserInfo', response.user, {root: true})
          store.commit('setAuthorized', true, {root: true})
          restfulApi.configureRestfulData(response)
        }
        return response
      }).catch(reject => {
        restfulApi.configureRestfulData(reject)
        if (reject.links && Array.isArray(reject.links)) {
          return reject
        }
        throw reject
      })
    }
  }
}
